module.exports = __webpack_public_path__ + "static/media/wy.50990ea.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/person/wy.mp4
// module id = st/S
// module chunks = 1